(function(){
  'use strict';

  function detailService(RestangularExt){
    var url = '/instellingen/website-blok-bodem';
    var _cache = null;

    function getBlockContent(){
      if(_cache === null){
        _cache = RestangularExt.all('proxy').customGET(null, {url: url});
      }
      return _cache;
    }

    return {
      getBlockContent : getBlockContent
    }

  }

  angular
    .module('wml.portal.detailPage')
    .factory('detailService', detailService);

})();
